
import { defineComponent, PropType } from 'vue'
import { DialogAction } from '@/types/dialog'
import { IconType } from '@/enums/IconType'
import Button, { ButtonThemeStyle, ButtonSizeStyle } from '@/components/base/Button.vue'
import ButtonRack, { ButtonRackDirectionType } from '@/components/base/ButtonRack.vue'
import Icon from '@/components/base/Icon.vue'
import SwipeablePanel from '@/components/base/SwipeablePanel.vue'

export default defineComponent({
  components: {
    Button,
    ButtonRack,
    Icon,
    SwipeablePanel,
  },
  emits: ['click', 'close'],
  props: {
    closeable: Boolean,
    message: {
      type: String,
      required: true,
    },
    action1: {
      type: Object as PropType<DialogAction>,
      required: true,
    },
    action2: {
      type: Object as PropType<DialogAction>,
      required: true,
    },
  },
  setup() {
    return {
      ButtonRackDirectionType,
      ButtonSizeStyle,
      ButtonThemeStyle,
      IconType,
    }
  },
})
